import React from "react";
import PropTypes from "prop-types";
import VmoButton from "../Elements/VmoButton/VmoButton";
import VmoModal from "../Modules/Modal/VmoModal";
import VmoModalActions from "../Modules/Modal/VmoModalActions";
import VmoModalContent from "../Modules/Modal/VmoModalContent";
import VmoModalHeader from "../Modules/Modal/VmoModalHeader";

const VmoLogoutModal = ({
  open = false,
  onClose = () => null,
  onLogout = () => null,
  isLoading = false,
  header = "Logout From Veemo",
  subHeader = "Are you sure you want to logout?",
  centered = false,
}) => {
  return (
    <VmoModal centered={centered} size="tiny" open={open} onClose={onClose}>
      <VmoModalHeader>{header}</VmoModalHeader>
      <VmoModalContent>{subHeader}</VmoModalContent>
      <VmoModalActions>
        <VmoButton basic onClick={onClose}>
          Cancel
        </VmoButton>
        <VmoButton primary loading={isLoading} onClick={onLogout}>
          Yes
        </VmoButton>
      </VmoModalActions>
    </VmoModal>
  );
}
export default VmoLogoutModal;

VmoLogoutModal.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    onLogout: PropTypes.func,
    isLoading: PropTypes.bool,
    header: PropTypes.string,
    subHeader: PropTypes.string, 
    centered:  PropTypes.bool,  
};

VmoLogoutModal.defaultProps = {
    open: false,
    onClose: () => null,
    onLogout: () => null,
    isLoading: false,
    header: "Logout From Veemo",
    subHeader: 'Are you sure you want to logout?',  
    centered: false
};